import { Encoder, MGPOptional, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { Move } from '../../jscaip/Move';
import { EncapsulePiece } from './EncapsulePiece';
export class EncapsuleMove extends Move {
    startingCoord;
    landingCoord;
    piece;
    static encoder = Encoder.tuple([MGPOptional.getEncoder(Coord.encoder), Coord.encoder, MGPOptional.getEncoder(EncapsulePiece.encoder)], (move) => [move.startingCoord, move.landingCoord, move.piece], (fields) => new EncapsuleMove(fields[0], fields[1], fields[2]));
    constructor(startingCoord, landingCoord, piece) {
        super();
        this.startingCoord = startingCoord;
        this.landingCoord = landingCoord;
        this.piece = piece;
    }
    static ofMove(startingCoord, landingCoord) {
        Utils.assert(startingCoord.equals(landingCoord) === false, 'Starting coord and landing coord must be separate coords');
        return new EncapsuleMove(MGPOptional.of(startingCoord), landingCoord, MGPOptional.empty());
    }
    static ofDrop(piece, landingCoord) {
        return new EncapsuleMove(MGPOptional.empty(), landingCoord, MGPOptional.of(piece));
    }
    isDropping() {
        return this.startingCoord.isAbsent();
    }
    equals(other) {
        if (this === other)
            return true;
        if (other.landingCoord.equals(this.landingCoord) === false)
            return false;
        if (this.startingCoord.equals(other.startingCoord) === false)
            return false;
        return this.piece.equals(other.piece);
    }
    toString() {
        if (this.isDropping()) {
            return 'EncapsuleMove(' + this.piece.get().toString() + ' -> ' + this.landingCoord + ')';
        }
        else {
            return 'EncapsuleMove(' + this.startingCoord.get() + '->' + this.landingCoord + ')';
        }
    }
}
